import DateFilter from "../../../components/rangePicker/rangePicker";
import {
	updateFilters,
	getDynFilterValues,
	setKeyFilterSelected,
} from "../../../redux/actions/photothequeActions";
import connect from "react-redux/es/connect/connect";

const mapStateToProps = (state, ownProps) => {
	return {
		currentFilters: state.phototheque.currentFilters
			? state.phototheque.currentFilters[ownProps.filterTargetKey]
			: [],
		minDate:
			state.phototheque.filters && state.phototheque.filters.period
				? state.phototheque.filters.period[0]
				: null,
		maxDate:
			state.phototheque.filters && state.phototheque.filters.period
				? state.phototheque.filters.period[1]
				: null,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addFilter: values => {
			dispatch(updateFilters(ownProps.filterTargetKey, values));
		},
		setKeyFilterSelected: () =>
			dispatch(setKeyFilterSelected(ownProps.filterTargetKey)),
		getDynFilterValues: () =>
			dispatch(getDynFilterValues(ownProps.filterTargetKey)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DateFilter);



// WEBPACK FOOTER //
// src/containers/activite/phototeque/DateFilterContainer.js